import DetailPageField from './DetailPageField.component';

export default DetailPageField;